import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { ProgramNextWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { LocalChannel } from '../../interfaces/local-channel'
import { ChannelService } from '../../services/channel.service'
import { EpgService } from '../../services/epg.service'

@Component({
  selector: 'app-program-next',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './program-next.component.html',
  styleUrls: [],
})
export class ProgramNextComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: ProgramNextWidget

  text = ''

  constructor(
    private epgService: EpgService,
    private channelService: ChannelService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.channelService.currentChannel$.subscribe((channel: LocalChannel | undefined) => {
        if (channel) {
          const liveEPG = this.epgService.getChannelLiveEPG(channel.id)
          this.text = liveEPG?.nextProgram?.title ?? ''
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
